import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/common/States";

export default function NotFoundPage() {
  return (
    <div className="lm-container py-16">
      <EmptyState icon={Compass} title="Page introuvable" description="Cette page n'existe pas ou a été déplacée." testId="not-found"
        action={<Button asChild className="rounded-full"><Link to="/">Retour à l'accueil</Link></Button>} />
    </div>
  );
}
